// usage.ts - shared formatting for the metering window, so the dashboard,
// submit page, and admin surfaces label limits identically.

import type { UsagePeriod } from '@/lib/api';

// "month" → "Monthly", etc. Title-case adjective for headings/badges.
export function periodLabel(p: UsagePeriod): string {
  return { hour: 'Hourly', day: 'Daily', month: 'Monthly', year: 'Yearly' }[p] ?? 'Monthly';
}

// "/ month" suffix for ratios and ceilings.
export function perPeriod(p: UsagePeriod): string {
  return `/ ${p}`;
}

// "this month", "this day" → the window an org is currently inside.
export function thisPeriod(p: UsagePeriod): string {
  return `this ${p}`;
}

// A usage_limit of 0 means unlimited (no contract volume set).
export function formatLimit(limit: number): string {
  return limit > 0 ? limit.toLocaleString() : 'Unlimited';
}

// Mirrors the backend's quota.DerivedLimit: ration the annual contract
// volume into the per-window allowance, so the admin UI previews exactly
// the number that will be enforced. 0 = unlimited (no contract).
export function derivedWindowLimit(period: UsagePeriod, submissionsPerYear: number): number {
  if (submissionsPerYear <= 0) return 0;
  const div = { hour: 365 * 24, day: 365, month: 12, year: 1 }[period] ?? 12;
  return Math.max(1, Math.floor(submissionsPerYear / div));
}

export const USAGE_PERIODS: UsagePeriod[] = ['hour', 'day', 'month', 'year'];
